export const COMPANY = {
  name: "Auto-Hire STL",
  legalName: "Charles Harold Washington Jr d.b.a Auto-Hire STL",
  tagline: "Drive Today. Pay Less. Stay Moving.",
  est: "EST. 2025",
  phone: "(314) 936-1837",
  phoneHref: "tel:+13149361837",
  email: "support@auto-hire.info",
  address: "Downtown St. Louis, MO 63101",
  logo: "https://customer-assets.emergentagent.com/job_web-constructor-199/artifacts/9kdk9ana_auto%20hire%20logo.png",
};

export const NAV_LINKS = [
  { label: "Fleet", href: "#fleet" },
  { label: "Pricing", href: "#pricing" },
  { label: "Features", href: "#features" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const SOCIALS = [
  { id: "instagram", label: "Instagram", url: "https://www.instagram.com/auto_hire_?igsh=czRkeWhvOGwwMXRq&utm_source=qr" },
  { id: "tiktok", label: "TikTok", url: "https://www.tiktok.com/@mr.autohire?_r=1&_t=ZP-97SinwWtHAc" },
  { id: "facebook", label: "Facebook", url: "https://www.facebook.com/share/1E3efpjeZp/?mibextid=wwXIfr" },
];

export const FB_REVIEW_URL = "https://www.facebook.com/profile.php?id=100090187809216&sk=reviews";

// Paste your Square payment link here to enable the "Pay with Square" button.
export const SQUARE_PAYMENT_URL = "https://square.link/u/qdtDNNK6";

export const STATS = [
  { value: "5", label: "Vehicles" },
  { value: "$0", label: "Security Deposit" },
  { value: "BYOI", label: "Or All-In Coverage" },
  { value: "24/7", label: "Local Support" },
];

// Pricing: byoi = Bring Your Own Insurance, allin = All-In Coverage
export const FLEET = [
  {
    id: "kia-rio", name: "Kia Rio", cat: "Economy", seats: 5, bags: 2,
    img: "https://images.unsplash.com/photo-1623869675781-80aa31012a5a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    byoiDay: 40, byoiWeek: 240, allinDay: 70, allinWeek: 390,
    blurb: "Fuel-sipping and budget-friendly. Perfect for daily driving and gig work.",
  },
  {
    id: "ford-focus", name: "Ford Focus", cat: "Compact", seats: 5, bags: 3,
    img: "https://images.unsplash.com/photo-1708401261557-050135dd9892?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    byoiDay: 60, byoiWeek: 350, allinDay: 90, allinWeek: 489,
    blurb: "Nimble, comfortable and efficient for city and highway alike.",
  },
  {
    id: "chevy-malibu", name: "Chevy Malibu", cat: "Midsize", seats: 5, bags: 4,
    img: "https://images.pexels.com/photos/11320433/pexels-photo-11320433.jpeg?auto=compress&cs=tinysrgb&w=1200",
    byoiDay: 75, byoiWeek: 420, allinDay: 105, allinWeek: 540,
    blurb: "Roomy, smooth and reliable — a favorite for rideshare and family trips.",
  },
  {
    id: "nissan-altima", name: "Nissan Altima", cat: "Midsize", seats: 5, bags: 4,
    img: "https://images.pexels.com/photos/15071553/pexels-photo-15071553.jpeg?auto=compress&cs=tinysrgb&w=1200",
    byoiDay: 75, byoiWeek: 420, allinDay: 105, allinWeek: 540,
    blurb: "Sporty and dependable with great mileage and a confident ride.",
  },
  {
    id: "ford-escape", name: "Ford Escape", cat: "SUV", seats: 5, bags: 4,
    img: "https://images.unsplash.com/photo-1758411898312-8592bb81e30d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    byoiDay: 75, byoiWeek: 350, allinDay: 105, allinWeek: 489,
    blurb: "Elevated SUV comfort and cargo room for any St. Louis adventure.",
  },
];

export const INSURANCE_OPTIONS = [
  {
    id: "BYOI", name: "Bring Your Own Insurance", short: "BYOI", featured: false,
    desc: "Use your own valid auto policy to unlock our lowest rates.",
    perks: [
      "Lowest daily & weekly rates",
      "Use your existing coverage",
      "Insurance verified before delivery",
      "Must meet Auto-Hire requirements",
    ],
  },
  {
    id: "AllIn", name: "All-In Coverage", short: "All-In", featured: true,
    desc: "No qualifying insurance? Drive with coverage included for one simple price.",
    perks: [
      "Rental + coverage in one price",
      "No personal policy required",
      "Fast approval",
      "Drive with peace of mind",
    ],
  },
];

export const ADDONS = {
  extraDriver: { label: "Additional Approved Driver", price: 15, unit: "/ day" },
  damageProtection: { label: "Damage Waiver / Damage Protection", price: 15, unit: "/ day" },
  youngDriverFee: { label: "Young Driver Fee (ages 21–24)", price: 25, unit: "/ day" },
};

export const FEATURES = [
  { icon: "Zap", title: "Fast Approval", desc: "A quick, simple approval process gets you on the road sooner." },
  { icon: "BadgeDollarSign", title: "Affordable Daily & Weekly Rates", desc: "Honest pricing on every vehicle, by the day or the week." },
  { icon: "ShieldCheck", title: "Flexible Insurance Options", desc: "Bring your own policy or add All-In Coverage — your choice." },
  { icon: "FileCheck", title: "Bring Your Own Insurance", desc: "Qualify for reduced rates using your own valid coverage." },
  { icon: "Umbrella", title: "All-In Coverage Available", desc: "No insurance? Drive with coverage included for one price." },
  { icon: "Car", title: "Rideshare Opportunities", desc: "Many vehicles may qualify for Uber, Lyft, DoorDash & more." },
  { icon: "Headphones", title: "Local Customer Support", desc: "Locally owned and operated, with real people who answer." },
];

export const WHY_CHOOSE = [
  "Affordable Daily & Weekly Rentals",
  "Flexible Insurance Options",
  "No Standard Security Deposit",
  "Fast Approval Process",
  "Locally Owned & Operated",
  "Reliable Vehicles",
  "Flexible Rental Programs",
  "Rideshare Opportunities for Approved Drivers",
];

export const FAQS = [
  { q: "Can I drive for Uber or Lyft?", a: "Possibly. Rideshare approval is subject to management approval, vehicle eligibility, insurance requirements, and platform standards. Additional details are provided during the approval process." },
  { q: "Can I use my own insurance?", a: "Yes. Customers with qualifying insurance may choose Bring Your Own Insurance pricing for our lowest rates." },
  { q: "What if I do not have insurance?", a: "Choose the All-In Coverage option and drive with coverage included for one simple price." },
  { q: "Are pets allowed?", a: "Yes, with prior approval." },
  { q: "Is smoking allowed?", a: "Yes. Auto-Hire vehicles are smoking-friendly. Excessive cleaning, burns, odors, or damage may result in additional charges." },
  { q: "Can someone else drive the vehicle?", a: "Only approved drivers listed on the rental agreement may operate the vehicle. Additional drivers are $15 per day." },
  { q: "What happens if I return the vehicle late?", a: "A 30-minute grace period applies. After the grace period, late fees begin at $25 per hour and additional rental charges may apply." },
  { q: "What is the fuel policy?", a: "Vehicles must be returned with the same fuel level provided at pickup. Fuel replacement and service fees may apply if returned with less fuel." },
  { q: "Do I pay anything when my reservation is approved?", a: "Yes. Once your reservation request is approved, a $20 reservation payment is required to confirm your booking. It is credited in full toward your rental total — it is not an additional fee. Cancel before your scheduled pickup for a refund or transfer; no-call/no-shows forfeit the $20 with no additional charge." },
];

export const DRIVER_REQUIREMENTS = [
  "Be at least 21 years old",
  "Possess a valid driver's license",
  "Provide a valid payment method",
  "Complete identity verification",
  "Meet Auto-Hire qualification requirements",
];
